import { PayloadRiskReportResults } from 'app/area/case-report/risk-listing/types-store';
import { DrillDownModel, DrillDownResult } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse, FavouriteDefinition, FavouriteLayoutModel } from 'app/types-shared';
import { endpoint } from './constants';
import { Codetable } from 'app/area/reports/types-api';

export const api = {
  executeRiskReport: async (definition: FavouriteDefinition, maxCaseNumbersPerCell: number): Promise<PayloadRiskReportResults> => {
    const response = await new RemoteData(endpoint.riskReport)
      .resource<Response>()
      .create({ favouriteDefinition: definition, maxCaseNumbersPerCell }, false);
    const json = await response.json();

    return json.data;
  },

  drilldown: async (definition: FavouriteDefinition, drillDownModel: DrillDownModel): Promise<DrillDownResult> => {
    const response = await new RemoteData(endpoint.drilldown(definition.favourite.v))
      .resource<Response>()
      .create(drillDownModel, false);
    const json = await response.json();

    return json.data;
  },

  reportLayout: async (favouriteId: number, report: number,
    layout: number, layoutTypeContextId: number): Promise<FavouriteLayoutModel> => {
    const response = await new RemoteData(endpoint.report)
      .resource<ApiResponse<FavouriteLayoutModel>>()
      .withId(`${report}/layout/${layout}`)
      .filter({
        layoutTypeContextId,
        favouriteId
      })
      .single();

    return response.data;
  },

  loadOptionsDrillDownTo: async (): Promise<ApiResponse<Codetable>> => {
    return await new RemoteData(endpoint.reportCategory)
      .resource<ApiResponse<Codetable>>()
      .filter({ allowDrillDownTo : true })
      .all();
  }
};
